import { z } from 'zod';

// Individual search result item
export const PredictiveSearchItemSchema = z.object({
    label: z.string(),
    image: z.string().nullable(),
    url: z.string(),
});

// "View All" link configuration for a group
export const PredictiveSearchGroupViewAllSchema = z.object({
    label: z.string(),
    href: z.string(),
});

// Search result group (e.g., "Partner Badges", "Experts & Agencies")
export const PredictiveSearchGroupSchema = z.object({
    group_label: z.string(),
    group_view_all: PredictiveSearchGroupViewAllSchema.nullable().optional(),
    has_images: z.boolean().optional(),
    items: z.array(PredictiveSearchItemSchema),
});

// Full response with dynamic groups
export const PredictiveSearchResponseSchema = z.object({
    groups: z.array(PredictiveSearchGroupSchema),
});

// TypeScript type exports
export type PredictiveSearchItem = z.infer<typeof PredictiveSearchItemSchema>;
export type PredictiveSearchGroupViewAll = z.infer<typeof PredictiveSearchGroupViewAllSchema>;
export type PredictiveSearchGroup = z.infer<typeof PredictiveSearchGroupSchema>;
export type PredictiveSearchResponse = z.infer<typeof PredictiveSearchResponseSchema>;

